<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <!-- <el-breadcrumb-item to="/feature/intro">学院概况</el-breadcrumb-item> -->
        <el-breadcrumb-item :to="`${$subsitePrefix}/major`">专业信息</el-breadcrumb-item>
        <el-breadcrumb-item>专业简介</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content">
        <h3 class="title">{{ currentMajor.Name }}</h3>
        <div class="content" v-html="currentMajor.Introduction"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState('college', ['currentMajor'])
  },
  mounted() {
    if (!this.currentMajor) {
      this.$router.push(this.$subsitePrefix + '/major')
    }
  },
  components: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding-bottom: 16px;
    line-height: 1.4em;
  }
  .content {
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    line-height: 1.8em;
    ::v-deep p {
      text-indent: 2em;
      padding-bottom: 1em;
    }
  }
}
</style>
